<template>
  <el-row>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-input
          clearable
          v-model="keyword"
          @input="searchHandle"
          placeholder="搜索关键字(微信昵称)"
          prefix-icon="el-icon-search"
          style="width:280px"
          size="small">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button :type="appType === '' ? 'primary' : ''" size="small" @click="appTypeChange('')">全部</el-button>
          <el-button :type="appType === 'fb' ? 'primary' : ''" size="small" @click="appTypeChange('fb')">两眼抹黑</el-button>
          <el-button :type="appType === 'neier' ? 'primary' : ''" size="small" @click="appTypeChange('neier')">内耳</el-button>
          <el-button :type="appType === 'movie_center' ? 'primary' : ''" size="small" @click="appTypeChange('movie_center')">影像中心</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-refresh" @click="searchHandle" size="small">刷新</el-button>
        <el-button type="primary" icon="el-icon-download" size="small">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="visitorList"
      border
      stripe
      :header-row-style="{color:'#333333'}"
      :cell-style="{padding:'8px 2px'}"
      style="width: 100%">
      <el-table-column
        label="微信"
        width="150">
        <template slot-scope="scope">
          <div class="head" v-if="scope.row.wechat && scope.row.wechat.headimgurl">
            <div class="head-url">
              <img :src="scope.row.wechat.headimgurl">
            </div>
            <p class="name">{{scope.row.wechat.nickname}}</p>&nbsp;
            <el-tag :type="scope.row.wechat.gender==='男'? 'success':'warning'" size="mini">{{scope.row.wechat.gender}}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="用户名"
        width="100">
        <template slot-scope="scope">
          <div class="user">
            <p
              class="user-name cursor-pointer"
              v-if="scope.row.user"
              @click="showUserMessage(scope.row.user)">
              {{scope.row.user.name}}
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="地区"
        prop="city"
        width="130">
        <template slot-scope="scope">
          <p>
            <span v-if="scope.row.province">{{scope.row.province}}-</span>
            <span>{{scope.row.city || '未知'}}</span>
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="IP地址"
        prop="ip"
        width="150">
      </el-table-column>
      <el-table-column
        label="设备类型"
        width="200">
        <template slot-scope="scope">
          <p v-if="scope.row.device.type">
            {{scope.row.platform.type}} {{scope.row.platform.version}}
            <el-tag v-if="scope.row.device.is_wifi" type="success" size="mini">wifi</el-tag>
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="应用"
        width="150">
        <template slot-scope="scope">
          <p v-if="scope.row.app">
            {{getAppName(scope.row.app)}}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="访问页面"
        width="250">
        <template slot-scope="scope">
          <p v-if="scope.row.page">{{scope.row.page.title && sliceStr(scope.row.page.title, 18)}}</p>
        </template>
      </el-table-column>
      <el-table-column
        label="访问日期"
        width="150">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.visit_at" :open-delay="300" placement="top-start">
            <span>{{getDay(scope.row.visit_at)}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="来源"
        width="200">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.origin.title" :open-delay="300" v-if="scope.row.origin">
            <a
              class="origin-link"
              target="_blank"
              :href="scope.row.origin.url"
              style="text-decoration:none">
              {{scope.row.origin.title && sliceStr(scope.row.origin.title, 18)}}
            </a>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="转发者">
        <template slot-scope="scope">
          <div class="head" v-if="scope.row.share_by">
            <div class="head-url">
              <img :src="scope.row.share_by.headimg || $store.state.default_img_url">
            </div>
            <p class="name">{{scope.row.share_by && scope.row.share_by.name}}</p>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      background
      :page-size="per_page"
      layout="total, prev, pager, next, jumper"
      @current-change="currentPageChange"
      :total="total">
    </el-pagination>
  </el-row>
</template>
<script>
import request from '@/utils/request'
import getDay from '@/utils/getDay'
export default {
  name: 'visitorList',
  data () {
    return {
      page: 1,
      total: 0,
      visitorList: [],
      per_page: 15,
      keyword: '',
      appType: ''
    }
  },
  mounted () {
    this.getVisitorList()
  },
  methods: {
    // page 变化
    currentPageChange (page) {
      this.page = page
      this.getVisitorList()
    },
    // 获取访客列表
    getVisitorList () {
      let sendData = {
        per_page: this.per_page,
        page: this.page,
        key: this.keyword,
        app: this.appType
      }
      request({
        url: 'visitors',
        method: 'get',
        params: sendData
      }).then(res => {
        this.total = res.data.item_total
        this.visitorList = res.data.list
      })
    },
    appTypeChange (e) {
      this.page = 1
      if (e === this.appType) return
      this.appType = e
      this.getVisitorList()
    },
    // 搜索
    searchHandle () {
      this.page = 1
      this.getVisitorList()
    },
    showUserMessage (item) {
      this.$userLayer.show(item)
    },
    sliceStr (str, num) {
      num = num || 10
      // console.log(str)
      if (str.length > num) {
        return str.slice(0, num) + '...'
      } else {
        return str
      }
    },
    mapClientType (client) {
      let type = {
        mobile_web: 'H5版',
        pc_web: 'PC网页版',
        miniapp: '小程序',
        ios_app: 'ios App',
        android_app: '安卓App'
      }
      return type[client]
    },
    getAppName (client) {
      let type = {
        flyingblind: 'FB商城',
        fb: 'FB商城',
        neier: '内耳小程序',
        movie_center: '影像中心'
      }
      return type[client]
    },
    getDay (date) {
      return getDay(date)
    }
  }
}
</script>
<style lang="less" scoped>
.head {
  display: flex;
  align-items: center;
  .head-url {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .name {
    flex: 1;
    margin-left: 10px;
  }
}
.user-name, .origin-link {
  color: #3c8dbc;
}
.pager {
  margin-top: 15px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/visitor/list.vue